export default __webpack_public_path__ + "static/media/login_background.450fd789.jpg";